import { apiGet } from './client';
import type {
  DisclosureDetail,
  DisclosureListQuery,
  DisclosureListResponse,
} from '../pages/DataExplorer/disclosures.types';

// 권위: docs/ARCH_DASHBOARD.md §4.6 탭 6-A + §6.2 REST 규약.
// 백엔드 엔드포인트 (dashboard-api 병렬 작업 중 — 스펙 가정):
//   GET /api/v1/disclosures
//     query:
//       from, to, symbol, q, event_type, review_status, page, page_size
//   GET /api/v1/disclosures/{auditId}
//
// envelope 언랩은 apiClient interceptor 가 자동 처리.

const BASE = '/api/v1/disclosures';

function buildListParams(q: DisclosureListQuery): Record<string, string> {
  const params: Record<string, string> = {
    page: String(q.page),
    page_size: String(q.page_size),
  };
  if (q.from) params.from = q.from;
  if (q.to) params.to = q.to;
  if (q.symbol) params.symbol = q.symbol;
  if (q.q) params.q = q.q;
  if (q.event_type) params.event_type = q.event_type;
  if (q.review_status) params.review_status = q.review_status;
  if (q.include_failed) params.include_failed = 'true';
  return params;
}

export async function listDisclosures(
  query: DisclosureListQuery
): Promise<DisclosureListResponse> {
  const qs = new URLSearchParams(buildListParams(query)).toString();
  return apiGet<DisclosureListResponse>(`${BASE}?${qs}`);
}

export async function getDisclosureDetail(auditId: number): Promise<DisclosureDetail> {
  return apiGet<DisclosureDetail>(`${BASE}/${auditId}`);
}
